import "antd/dist/reset.css";
import { Collapse, Tree, Descriptions, Rate } from "antd";
import React, { useState, useEffect } from "react";
import "./SOSSummaryChild.scss";
import utils from "utils";

const { Panel } = Collapse;

const TPNSummary = ({ data }) => {
  const [resultObjects, setResultObjects] = useState([]);

  useEffect(() => {
    let final_arr = [];
    if (data.length > 0) {
      for (const item of data) {
        let textItems = [];
        for (const key in item.values) {
          if (
            item.values[key].field_type === "text" ||
            item.values[key].field_type == "integer" ||
            item.values[key].label == "Psychotherapy Goal Progress Rating"
          ) {
            if (
              item.values[key].values.length > 0 ||
              item.values[key].field_type == "integer" ||
              (item.values[key].label == "Psychotherapy Goal Progress Rating" &&
                item.values[key].values > 0)
            ) {
              let temp_obj = {
                label: item.values[key].label,
                value: Array.isArray(item.values[key].values)
                  ? item.values[key].values.join(", ")
                  : item.values[key].values,
                type:
                  item.values[key].field_type == "integer" ||
                  item.values[key].label == "Psychotherapy Goal Progress Rating"
                    ? "rate"
                    : undefined,
              };
              textItems.push(temp_obj);
            }
          } else if (item.values[key].label == "Psychotherapy Goal") {
            let treeData = [];
            item.values[key]?.values.forEach((category) => {
              let childrenPresent = [];
              category.values.forEach((valueObj) => {
                if (valueObj.is_selected)
                  childrenPresent.push({
                    title: valueObj.label,
                    key: valueObj.label + item.completion_date+category.label,
                  });
              });
              if (childrenPresent.length > 0)
                treeData.push({
                  title: category.label,
                  key: category.label + item.completion_date,
                  children: [...childrenPresent],
                });
            });
            textItems.push({
              treeData,
              type: "tree",
              label: item.values[key].label,
            });
          }
        }
        let obj = {
          completion_date: item.completion_date,
          consultation_doctor: item.consultation_doctor,
          doctor_salutation: item.doctor_salutation,
          doctor_last_name: item.doctor_last_name,
          values: textItems,
        };
        final_arr.push(obj);
        setResultObjects(final_arr);
      }
    }
  }, [data]);
  return (
    <>
      {resultObjects.length > 0 ? (
        <div className="therapy-progress-content">
          {resultObjects.map((item, k) => (
            <Collapse
              style={{ overflowY: "auto" }}
              bordered={false}
              expandIconPosition="start"
              ghost={true}
              className="mhe-list-container"
              key={k}
            >
              <Panel
                header={
                  <div>
                    {utils.FormatDate(item.completion_date, "DATE_14")},{" "}
                    {utils.FormatDate(item.completion_date, "TIME_1")}
                  </div>
                }
                extra={utils.FirstNameLastName(utils.salutationPrefixName(item?.doctor_salutation,utils.getDisplayName(item.consultation_doctor, item.doctor_last_name)), "250px")}
                key="1"
              >
                <Descriptions
                  size="middle"
                  bordered
                  layout="horizontal"
                  labelStyle={{ width: "40%" }}
                  column={1}
                >
                  {item.values.map((nestItem, id) => (
                    <Descriptions.Item label={nestItem.label} key={id}>
                      {nestItem?.type == "tree" ? (
                        <Tree defaultExpandAll treeData={nestItem.treeData} />
                      ) : nestItem?.type == "rate" ? (
                        <Rate
                          count={10}
                          defaultValue={nestItem.value}
                          disabled={true}
                        />
                      ) : (
                        nestItem.value
                      )}
                    </Descriptions.Item>
                  ))}
                </Descriptions>
              </Panel>
            </Collapse>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default TPNSummary;
